import { constants } from "redux/constants/redux-constants";

const initialState = {
  // Outcome of the most recent screen data-load the copilot cares about,
  // published from the fetch's response-resolution site (setLoadResult) and
  // consumed by copilot actions via waitForLoadResult. Each new load first
  // writes a `loading` status (so a waiter never matches a stale terminal
  // outcome), then the real terminal status once the response settles.
  result: null,
};

const copilotLoadReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_COPILOT_LOAD_RESULT:
      return {
        ...state,
        result: {
          key: action.payload.key,
          status: action.payload.status,
          at: action.payload.at,
        },
      };
    default:
      return state;
  }
};

export default copilotLoadReducer;
